<template>
  <div>
    <div class="content-block dx-card responsive-paddings">
      <h2>An error has occurred</h2>
      <p>
        <strong v-if="prevRoute">{{ url }}</strong
        ><span v-else>Page</span> could not be found.
      </p>
      <p>
        You can return to the
        <router-link :to="{ name: 'statements' }">statements page</router-link>
        or submit a bug report if the issue persists.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  data() {
    return {
      prevRoute: null,
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = to.redirectedFrom
    })
  },
  computed: {
    url() {
      return `${window.location.protocol}//${window.location.hostname}${this.prevRoute}`
    },
  },
}
</script>
